/* global axios */
import ApiClient from './ApiClient';

class CallDevicesAPI extends ApiClient {
  constructor() {
    super('call_devices', { accountScoped: true });
  }

  // GET /api/v1/accounts/:accountId/call_devices → [{id, name, ...}]
  index() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:accountId/call_devices/inbox_map → [{id, name, inbox_id}]
  // Lightweight, readable by any member — used by the call-button gate.
  inboxMap() {
    return axios.get(`${this.url}/inbox_map`);
  }

  // POST /api/v1/accounts/:accountId/call_devices  body: {name}
  create(data) {
    return axios.post(this.url, data);
  }

  // GET /api/v1/accounts/:accountId/call_devices/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // PATCH /api/v1/accounts/:accountId/call_devices/:id  body: {inbox_id, name}
  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { call_device: payload });
  }

  // DELETE /api/v1/accounts/:accountId/call_devices/:id
  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:accountId/call_devices/:id/pair  — re-emit fresh QR
  pair(id) {
    return axios.post(`${this.url}/${id}/pair`);
  }

  // POST /api/v1/accounts/:accountId/call_devices/:id/logout
  logout(id) {
    return axios.post(`${this.url}/${id}/logout`);
  }

  // GET /api/v1/accounts/:accountId/call_devices/:id/stats
  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }

  // GET /api/v1/accounts/:accountId/calling_plan
  callingPlan() {
    return axios.get(`${this.baseUrl()}/calling_plan`);
  }
}

export default new CallDevicesAPI();
